module.exports = __webpack_public_path__ + "img/drh5_btn_clo.7a33dbdf.png";